import React from 'react';
import { PropTypes } from 'prop-types';

const SlantedDivider = ({ styles }) => {
    return (
        <div className={styles.container}>
            <svg width="15" height="1000" viewBox="0 0 15 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 1L0.999999 14L0.999999 1000" strokeWidth="2" />
            </svg>
        </div>
    );
};

SlantedDivider.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
    }).isRequired,
};

export default SlantedDivider;
